import {Card, Stack} from '@mui/material';
import {FlowEnum} from 'presentation/modules/booking/shared/constants/flowEnum';
import {AppointmentAddress} from 'presentation/modules/booking/shared/ui/components/ConfirmationBooking/AppointmentAddress';
import {AppointmentInfoList} from 'presentation/modules/booking/shared/ui/components/ConfirmationBooking/AppointmentInfoList';
import React from 'react';
import {HealthConfirmBookingButton} from '../HealthReviewBooking/components/HealthConfirmBookingButton';
import {useHealthReviewBookingNew} from './hooks/useHealthReviewBookingNew';
import {StyledContainer} from './styles';
import {HealthReviewBookingNewProps} from './types';

export function HealthReviewBookingNew({handlePrevStep}: HealthReviewBookingNewProps) {
	const {
		beneficiaryName,
		planName,
		providerName,
		specialtyName,
		clinicName,
		date,
		hour,
		formattedAddress,
		addressForMaps,
		handleOpenGoogleMaps,
	} = useHealthReviewBookingNew();

	return (
		<StyledContainer>
			<Card elevation={0} sx={{borderRadius: 2, p: 3}}>
				<Stack gap={3}>
					<AppointmentInfoList
						beneficiaryName={beneficiaryName}
						planName={planName}
						providerName={providerName}
						specialtyName={specialtyName}
						clinicName={clinicName}
						date={date}
						hour={hour}
						flowType={FlowEnum.HEALTH}
					/>
					<AppointmentAddress
						formattedAddress={formattedAddress}
						addressForMaps={addressForMaps}
						handleOpenMap={handleOpenGoogleMaps}
					/>
				</Stack>
			</Card>
			<HealthConfirmBookingButton handleBack={handlePrevStep} />
		</StyledContainer>
	);
}
